import type { DeveloperResources } from '../en/developer';

export const developer: DeveloperResources = {
  demo: {
    title: 'Demo',
  },
  resetSeed: {
    title: 'Seed-Daten zurücksetzen',
    description: 'Verwirft und erzeugt Fahrzeuge, Mandanten und Grant-Ledger-Einträge mit dem Standardszenario neu.',
    button: 'Seed-Daten zurücksetzen',
    resetting: 'Wird zurückgesetzt…',
    success: 'Seed-Daten erfolgreich zurückgesetzt.',
    error: 'Zurücksetzen fehlgeschlagen. Prüfen Sie die Konsole für Details.',
  },
  health: {
    title: 'Systemstatus',
    error: 'Der Health-Status konnte nicht abgerufen werden.',
    timestamp: 'Zeitstempel',
    uptime: 'Betriebszeit',
    uptimeValue: '{{seconds}}s',
  },
  session: {
    title: 'Sitzung',
    user: 'Benutzer: {{name}}',
    currentTenant: 'Aktueller Mandant: {{name}}',
    apexFallback: '— (Apex)',
    availableTenants: 'Verfügbare Mandanten: {{tenants}}',
    logout: 'Abmelden',
  },
};
